import { Skeleton } from '../../../shared/ui'

const TILES = Array.from({ length: 8 }, (_, i) => i)
const ROWS = Array.from({ length: 4 }, (_, i) => i)

export function DashboardSkeleton() {
  return (
    <div className="od-stack" role="status" aria-label="Loading outreach stats" aria-busy="true">
      <div className="stats-bar cols4">
        {TILES.map((i) => (
          <div className="stat-cell" key={i}>
            <div className="stat-label">
              <Skeleton width="40" />
            </div>
            <div className="stat-value">
              <Skeleton width="70" />
            </div>
          </div>
        ))}
      </div>
      <div className="table-wrap">
        <table aria-hidden="true">
          <tbody>
            {ROWS.map((i) => (
              <tr key={i} className="skel-row">
                <td>
                  <Skeleton />
                </td>
                <td>
                  <Skeleton width="40" />
                </td>
                <td>
                  <Skeleton width="70" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
